module.exports = __webpack_public_path__ + "img/b-logo.3248e101.png";